import { urlFor } from '@lib/sanity'
import React from 'react'
// All section components loaded statically to avoid hydration mismatch (dynamic chunks render null on client until loaded)
import Hero from '@components/ui/Hero'
import IconTextList from '@components/ui/IconTextList'
import TickerList from '@components/ui/TickerList'
import QuoteBar from '@components/ui/QuoteBar'
import HowItWorks from '@components/ui/HowItWorks'
import AccuracySecurity from '@components/ui/AccuracySecurity'
import TrustPilot from '@components/ui/TrustPilot'
import FreeText from '@components/ui/FreeText'
import AccordionManager from '@components/ui/AccordionManager'
import DocAd from '@components/ui/DocAd'
import DocAdTwo from '@components/ui/DocAdTwo'
import AccordionContainer from '@components/ui/AccordionContainer'
import Video from '@components/ui/Video'
import Reviews from '@components/ui/Reviews'
import ReviewsSmall from '@components/ui/ReviewsSmall'
import Teaser from '@components/ui/Teaser'
import BlogTeaser from '@components/ui/BlogTeaser'
import ProductTeaser from '@components/ui/ProductTeaser'
import FeatureTeaser from '@components/ui/FeatureTeaser'
import ProdTickerList from '@components/ui/ProdTickerList'
import ChipsList from '@components/ui/ChipsList'
import Partners from '@components/ui/Partners'
import OrderTeaser from '@components/ui/OrderTeaser'
import OrderTeaserTwo from '@components/ui/OrderTeaserTwo'
import Press from '@components/ui/Press'
import WhyShouldITest from '@components/ui/WhyShouldITest'
import CenteredIcon from '@components/ui/CenteredIcon'

export default function renderSection(section: any, index?: number) {
  const key = section?._key ?? `section-${index ?? 0}`

  switch (section?._type) {
    case 'superHero':
      return (
        <Hero
          key={key}
          headline={section.title}
          url={section.url}
          cta={section.cta}
          image={urlFor(section?.image).url()}
          imageTwo={urlFor(section?.imageTwo).url()}
          imageMobile={urlFor(section?.imageMobile).url()}
          className={section.className}
          discounts={section.discounts}
          usps={section.uspSliderProduct}
          prodInfo={section.productInfoSidebar}
          howTo={section.howToSidebar}
        />
      )

    // case 'videoRow':
    //   return (
    //     <Video title={section.title} content={section.content} url={section.url} key={key} />
    //   )

    case 'valueProps':
      return (
        <IconTextList title={section.title} subtitle={section.subtitle} list={section.items} key={key} />
      )

    case 'reviews':
      return (
        <Reviews className={section.className} title={section.title} rating={section.rating} reviewers={section.reviewers} recommended={section.recommended} list={section.items} key={key} />
      )

    case 'reviewsSmall':
      return (
        <ReviewsSmall className={section.className} rating={section.rating} reviewers={section.reviewers} recommended={section.recommended} key={key} />
      )

    case 'valueTicker':
      return (
        <TickerList title={section.title} list={section.items} key={key} />
      )

    case 'press':
      return (
        <Press title={section.title} list={section.items} key={key} />
      )

    case 'prodValueTicker':
      return (
        <ProdTickerList title={section.title} list={section.items} key={key} />
      )

    case 'quoteBar':
      return (
        <QuoteBar icon={section?.icon} text={section?.title} author={section?.subtitle} key={key} />
      )

    case 'trustPilotBox':
      return (
        <TrustPilot href={'#'} image={urlFor(section?.image).width(200).url()} key={key} />
      )

    case 'fourColumnUp':
      return (
        <HowItWorks title={section?.title} color={section.color || ''} image={urlFor(section?.image).width(800).url()} key={key}>
          {
            <AccordionManager items={section?.items} small={true} />
          }
        </HowItWorks>
      )

    case 'twoColumnUp':
      return (
        <DocAd title={section.title} buttonText={section.button_text} variantId={section.variantId} image={urlFor(section?.image).url()} list={section.items} key={key} />
      )

    case 'textImage':
      return (
        <DocAdTwo title={section.title} image={urlFor(section?.image).url()} text={section.content} key={key} />
      )

    case 'threeColumnList':
      return (
        <WhyShouldITest title={section.title} image={urlFor(section?.image).url()} list={section.items} key={key} />
      )

    case 'fourColumnUpOrderTeaser':
      return (
        <OrderTeaser title={section.title} subtitle={section.subtitle} variantId={section.variantId} buttonText={section.button_text} image={urlFor(section?.image).url()} text={section.text} list={section.items} key={key} />
      )

    case 'fourColumnUpOrderTeaserTwo':
      return (
        <OrderTeaserTwo title={section.title} subtitle={section.subtitle} variantId={section.variantId} buttonText={section.button_text} image={urlFor(section?.image).url()} logo={urlFor(section?.logo).url()} text={section.text} list={section.items} key={key} />
      )

    case 'threeColumnUp':
      return (
        <AccuracySecurity title={section.title} titleLineTwo={section.titleLineTwo} image={urlFor(section?.image).width(800).url()}
                          variant2={section.variant2} extraText={section.extraText} icon={urlFor(section?.icon).width(300).url()} list={section.items} key={key} />
      )

    case 'freeTextBox':
      return (
        <FreeText title={section.title} text={section.content} key={key} />
      )

    case 'centeredIcon':
      return (
        <CenteredIcon title={section.title} icon={urlFor(section?.icon).url()} key={key} />
      )

    case 'teaser':
      return (
        <Teaser title={section.title} colorLight={section.colorLight} text={section.text} image={urlFor(section?.image).url()} cta={section.cta} url={section.url} key={key} />
      )

    case 'faqs':
      return (
        <AccordionContainer key={key} color={section.color || ''} colorDark={section.colorDark || ''} className={section.className || ''} title={section.title || null}>
          {
            <AccordionManager items={section?.items} small={false} />
          }
        </AccordionContainer>
      )
    case 'blogTeaser':
      return (
        <BlogTeaser title={section.title} teaserUrl={section.teaserUrl} teaserText={section.teaserText} list={section.items} key={key} />
      )
    case 'productTeaser':
      return (
        <ProductTeaser title={section.title} productPage={section.productPage} imageHelper={urlFor(section.image).url()} list={section.items} key={key} />
      )
    case 'partners':
      return (
        <Partners title={section.title} list={section.items} key={key} />
      )
    case 'featureComparison':
      return (
        <FeatureTeaser title={section.title} subtitle={section.subtitle} list={section.items} key={key} />
      )
    case 'chipsList':
      return (
        <ChipsList list={section.items} key={key} />
      )
  }
  return null
}
